import { AegisClient } from '@nike/aegis-auth-react'
import config from '../config'

const aegisClient = new AegisClient(config.oAuth)

export default aegisClient
